import { useState } from "react";
import { BtnStateE } from "@components/Pages/Clients/useClientsControl";

interface MoreClientModalControlI {
  readonly isHashState: boolean;

  setChartState(s: BtnStateE): void;
}

export const useMoreClientModalControl = (): MoreClientModalControlI => {
  const [chartState, setChartState] = useState<BtnStateE>(BtnStateE.HASH);

  const isHashState = chartState === BtnStateE.HASH;

  return {
    isHashState,

    setChartState,
  };
};
